export default {"src":"/_next/static/media/hero.6447a18a.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};